var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Text } from "../..";
export var CardHeaderTitle = function (_a) {
    var title = _a.title, titleLss = _a.titleLss;
    return (React.createElement(Text, { as: "h2", lss: __assign({ ml: 'xxs', my: 0, textAlign: 'left', lineHeight: 1.3 }, titleLss) }, title));
};
//# sourceMappingURL=CardHeaderTitle.js.map